import api from '@/utils/api';

/**
 * Check is user is archived
 * @param {object} userEmail - The user email
 * @returns {Promise}
 */
const checkUserArchivedStatus = (userEmail) =>
  api.post('/user/is-archived', userEmail);

export default checkUserArchivedStatus;
